<template>
  <div class="m-container m-pt-24">
    <p class="m-text-center m-font-size-400">Tu nič nie je</p>
  </div>
</template>
